import { Grid, Typography } from '@mui/material';
import { ArrowDownIcon } from '../../../assets/images';
import { MuiStack } from '../../../components';
import { MuiIconButton } from '../../../components/atoms/iconButtonComponent';
import { useAppSelector } from '../../../store/hooks';
var SourceLocationCell = function (props) {
    var _crud$stockTransferRe, _formData$SourceWareh, _formData$Destination, _mainData$SourceWareh, _mainData$Destination;
    var rowData = props.rowData, onButtonClick = props.onButtonClick, formData = props.formData;
    var hasRowData = Array.isArray(rowData) && rowData.length > 0;
    var firstRowData = hasRowData ? rowData[0] : null;
    var crud = useAppSelector(function (state) { return state.crud; });
    var mainData = crud === null || crud === void 0 || (_crud$stockTransferRe = crud.stockTransferRequisitionGetById) === null || _crud$stockTransferRe === void 0 ? void 0 : _crud$stockTransferRe.data;
    var LocationName = firstRowData ? firstRowData.LocationName || firstRowData.SourceLocationName || firstRowData.DestinationLocationName : null;
    var warehouseName = (formData === null || formData === void 0 || (_formData$SourceWareh = formData.SourceWarehouse) === null || _formData$SourceWareh === void 0 ? void 0 : _formData$SourceWareh.Name) || (formData === null || formData === void 0 || (_formData$Destination = formData.DestinationWarehouse) === null || _formData$Destination === void 0 ? void 0 : _formData$Destination.Name) || (firstRowData === null || firstRowData === void 0 ? void 0 : firstRowData.WarehouseName) || (mainData === null || mainData === void 0 || (_mainData$SourceWareh = mainData.SourceWarehouse) === null || _mainData$SourceWareh === void 0 ? void 0 : _mainData$SourceWareh.Name) || (mainData === null || mainData === void 0 || (_mainData$Destination = mainData.DestinationWarehouse) === null || _mainData$Destination === void 0 ? void 0 : _mainData$Destination.Name);
    return /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        justifyContent: 'center'
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        justifyContent: 'center',
        alignItems: 'center'
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 11
    }, LocationName ? /*#__PURE__*/ React.createElement(Typography, {
        color: '#8593A3',
        fontSize: '12px'
    }, warehouseName, " / ", LocationName) : /*#__PURE__*/ React.createElement(Typography, {
        color: '#8593A3',
        fontSize: '12px'
    }, "Select Location")), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 1
    }, /*#__PURE__*/ React.createElement(MuiIconButton, {
        onClick: onButtonClick,
        style: {
            alignContent: 'flex-end'
        }
    }, /*#__PURE__*/ React.createElement("img", {
        src: ArrowDownIcon,
        alt: "Arrow Down"
    })))));
};
export default SourceLocationCell;
